import React, { memo, useCallback } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { removePriceRange, addPriceRange } from 'Pods/SearchPage/Store/actions/pricing'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { priceRangeOptions } from './constants'

function RangeButtons() {
  const priceRanges = useSearchPageStore(state => state.priceRanges)

  const handlePriceRangeClick = useCallback((priceRange) => {
    if (priceRanges && priceRanges.includes(priceRange)) {
      removePriceRange(priceRange)
    } else {
      addPriceRange(priceRange)
    }
  }, [priceRanges])

  return (
    <div className="price-filter__range-buttons">
      {priceRangeOptions.map((option) => {
        const isSelected = priceRanges && priceRanges.includes(option.value)

        return (
          <Button
            key={option.value}
            type={isSelected ? 'primary' : 'secondary'}
            size="tiny"
            customClass="price-filter__range-button"
            isActive={isSelected}
            onClick={() => handlePriceRangeClick(option.value)}
          >
            {option.label}
          </Button>
        )
      })}
    </div>
  )
}

export default memo(RangeButtons)
